export default {
  // 门票充值，查询到的数据
  setTicketRecharge({ commit }, data) {
    commit("ticketRecharge", data);
  }
};
